import { highlightSearchMatch } from '@components'

import { Flex } from '@billy/design-system'
import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import type { ExpertProfitAndLossRowKind } from '../../../../types/expertProfitAndLossView'

interface ProfitAndLossLabelProps {
  kind: ExpertProfitAndLossRowKind
  label: string
  searchTerm?: string
}

export const ProfitAndLossLabel = ({ kind, label, searchTerm = '' }: ProfitAndLossLabelProps): ReactElement => {
  const isHighlighted = kind === 'result' || kind === 'subtotal'

  const text = (
    <Typography.Text title={label} weight={isHighlighted ? 'semibold' : 'regular'}>
      {highlightSearchMatch(label, searchTerm)}
    </Typography.Text>
  )

  if (isHighlighted) {
    return (
      <Flex data-testid="profit-and-loss-label-highlighted" justifyContent="flex-end" width="100%">
        {text}
      </Flex>
    )
  }

  return text
}
